module.exports = __webpack_public_path__ + "static/media/sketching.075606f9.jpg";